module.exports = __webpack_public_path__ + "media/images/country_flags/bt-190cc65b5a22afd568ebe41a6fb3ce23.png";